import React from 'react';
import TableReport from "../../../common/table/table";
import MessageEmptyData from "../../../common/messageEmptyData";
import {isEmpty} from "lodash"
import {tableColumns} from "./tableColumns";
import DrillerChart from './drillerChart';

/**
 * Body report component for daily summary report
 * @param prop
 * @returns {JSX.Element|null}
 * @constructor
 */
const DrillerProductionBody = (prop) => {
    const {reportFilters, tableData, barChartData, barChartLabels, chartAverageValue} = prop;

    if (!reportFilters.isSubmitted) {
        return null;
    }

    if (isEmpty(tableData)) {
        return <MessageEmptyData/>;
    }

    return (
        <div className="container-fluid">
            <TableReport
                columns={tableColumns}
                data={tableData}
                exportOptions={{pdf: false, xlsx: true, csv: true}}
                withGlobalSearch={false}
                scrollable={true}
                fixedTotalRow={true}
                lastRowsToExcludeFromSort={1}
            />
            <DrillerChart
                title='Driller Production'
                labels={barChartLabels}
                dataset={barChartData}
                averageValue={chartAverageValue}
            />
        </div>
    );
}

export default DrillerProductionBody;
